/**
 * ============================================================================
 * OPTIMIZED AND CORRECTED CART INITIALIZATION SCRIPT
 * ============================================================================
*/

// ---  Centralized Configuration ---
const CART_COMPONENTS = {
  SAMPLES_SLIDER: '#lt-cart-samples',
  PRODUCT_CAROUSEL: '#lt-cart-product-carousel',
  REDEEM_POINTS: '#es-cart-redeem-points',
  PROMO_PRODUCTS: '#multiple-promo-cart',
  RECOMMENDATIONS_CAROUSEL: '#es-cart-product-carousel',
  GIFT_NOTE_INPUT: '#GiftNote',
  LOYALTY_POINTS_DISPLAY: '#puntosLealtad'
};

let initTimeout;

function initializeCartComponents() {

  clearTimeout(initTimeout);
  
  initTimeout = setTimeout(() => {
    
    const noteInput = document.querySelector(CART_COMPONENTS.GIFT_NOTE_INPUT);

    if (noteInput && !noteInput.dataset.charCountInitialized) {
      const charCount = () => {
        const msg = document.getElementById('msg');
        if (msg) {
          const counter = noteInput.maxLength - noteInput.value.length;
          msg.textContent = `${counter} caracteres restantes`;
        }
      };
      noteInput.addEventListener('keyup', charCount);
      noteInput.dataset.charCountInitialized = 'true';
    }

    // --- Dispatch Custom Events for other scripts ---

    document.dispatchEvent(new CustomEvent('cart-recommended-updated', { detail: { message: 'Ready for recommendations.' }}));
    //console.log('%c[Cart Event] "cart-recommended-updated" dispatched.', 'color: #90EE90');

    document.dispatchEvent(new CustomEvent('cart-updated-billing', { detail: { message: 'Ready for recommendations.' }}));
    //console.log('%c[Cart Event] "cart-updated-billing" dispatched.', 'color: #90EE90');
    
    const loyaltyPointsEl = document.querySelector(CART_COMPONENTS.LOYALTY_POINTS_DISPLAY);

    if (loyaltyPointsEl && loyaltyPointsEl.textContent.trim() === '') {
      document.dispatchEvent(new CustomEvent('cart-updated-loccisoles', { detail: { message: 'Loyalty points need refresh.' }}));
      //console.log('%c[Cart Event] "cart-updated-loccisoles" dispatched.', 'color: #90EE90');
    }

  }, 250); 
}


function setupObserver() {

  const stableParent = 
    document.getElementById('shopify-section-main-cart') || 
    document.getElementById('MainContent') ||              
    document.body;                                         

  const config = { childList: true, subtree: true };
  const selectorsToWatch = Object.values(CART_COMPONENTS).join(', ');

  const observer = new MutationObserver((mutationsList) => {
  
    const hasRelevantChanges = mutationsList.some(mutation =>
      Array.from(mutation.addedNodes).some(node =>
        node.nodeType === Node.ELEMENT_NODE && (node.matches(selectorsToWatch) || node.querySelector(selectorsToWatch))
      )
    );

    if (hasRelevantChanges) {
      console.log('%c[Observer 👀] Relevant DOM change detected. Triggering re-initialization.', 'color: Cyan');
      initializeCartComponents();
    }
  });
  observer.observe(stableParent, config);
}


document.addEventListener('DOMContentLoaded', () => {
    initializeCartComponents();
    setupObserver();
});